
		export default class PageState{
			ww_token: string = ''
		}